import React from 'react';
import {
  Sparkles, Flame, Wine, Heart, Smile, Moon,
  Briefcase, PartyPopper,
} from 'lucide-react';

// Per-moment moods chosen by guests at upload time.
export const MOODS = [
  { value: 'magic',  Icon: Sparkles, label: 'Magic'  },
  { value: 'energy', Icon: Flame,    label: 'Energy' },
  { value: 'cheers', Icon: Wine,     label: 'Cheers' },
  { value: 'love',   Icon: Heart,    label: 'Love'   },
  { value: 'joy',    Icon: Smile,    label: 'Joy'    },
  { value: 'calm',   Icon: Moon,     label: 'Calm'   },
];

// Event-level vibes chosen by hosts at creation time.
export const VIBES = [
  { value: 'romantic',  Icon: Heart,       label: 'Romantic'  },
  { value: 'wild',      Icon: Flame,       label: 'Wild'      },
  { value: 'corporate', Icon: Briefcase,   label: 'Corporate' },
  { value: 'elegant',   Icon: Sparkles,    label: 'Elegant'   },
  { value: 'casual',    Icon: Smile,       label: 'Casual'    },
  { value: 'festive',   Icon: PartyPopper, label: 'Festive'   },
];

const MOOD_MAP = Object.fromEntries(MOODS.map((m) => [m.value, m]));
const VIBE_MAP = Object.fromEntries(VIBES.map((v) => [v.value, v]));

export function MoodIcon({ mood, className = 'w-5 h-5', ...rest }) {
  const Icon = MOOD_MAP[mood]?.Icon ?? Sparkles;
  return <Icon className={className} {...rest} />;
}

export function VibeIcon({ vibe, className = 'w-5 h-5', ...rest }) {
  const Icon = VIBE_MAP[vibe]?.Icon ?? Sparkles;
  return <Icon className={className} {...rest} />;
}
